import { AgentNotificationWebService } from '@linktivity/gds-neo';
import config from '../config';

const agentNotificationApi = new AgentNotificationWebService.NotificationApi(
  config
);

export default agentNotificationApi;
